module.exports = __webpack_public_path__ + "img/Ulta_case_study_3.11b6e0c9.jpg";